import React from "react";

import Typewriter from "typewriter-effect";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Button from "@mui/material/Button";

import Sec from "./Sec";

import "./About.css";
function Body() {
  return (
    <div className="body">
      <div className="container">
        <div className="row main-sec">
          <div className="col-xs-6 col-sm-6">
            <h3 className="text">
              {" "}
              <Typewriter
                options={{ delay: 100 }}
                onInit={(typewriter) => {
                  typewriter

                    .typeString(" Hi there <span>&#128075;</span>")
                    .pauseFor(1000)
                    .typeString(" I am Ashish Singh, <br/>")

                    .typeString("<b>Frontend</b> & ")

                    .typeString("<b>Backend Developer...</b> <br/><br/>")
                    .pauseFor(1000)

                    .start()

                    .pauseFor(1000)
                    .typeString(
                      'I love to build <span style="color: #27ae60;">next-Gen products</span> with the latest technologies.'
                    )
                    .pauseFor(2000)

                    .start();
                }}
              />
            </h3>
          </div>
          <div className="col-xs-6 col-sm-6 sec-half">
            <Sec />{" "}
          </div>
        </div>
        <div className="row">
          {" "}
          <Button
            className="res-btn"
            href="https://drive.google.com/file/d/1o5d4MwY5Ch7evUP27g3ODOftcsFp3HZ_/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
            style={{
              marginTop: "20px",
              marginLeft: "auto",
              marginRight: "auto",
              color: "teal",
              fontFamily: "cursive",
              textDecoration: "none",
              backgroundColor: "transparent",
              outline: "1px solid teal",
              marginBottom: "30px",
            }}
            variant="contained"
          >
            {" "}
            <b> View My Resume</b>{" "}
            <CloudDownloadIcon style={{ marginLeft: "5px" }} />
          </Button>{" "}
        </div>
      </div>
    </div>
  );
}

export default Body;
